import React from 'react';
export const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/3zVULXAcAAcS2CujfFojTe/LOGO-V1.jpg';
interface LogoProps {
  /** Height utilities for the mark, e.g. "h-12 lg:h-14". */
  className?: string;
  /** Renders the mark on a white plate so it reads on dark surfaces. */
  onDark?: boolean;
  /** Accessible name. Leave empty when a parent link already labels it. */
  alt?: string;
}
export function Logo({
  className = 'h-12',
  onDark = false,
  alt = ''
}: LogoProps) {
  const mark = <img src={LOGO_SRC} alt={alt} aria-hidden={alt ? undefined : true} className={`w-auto object-contain ${className}`} data-id="element-205" data-mp="rsh2sdqpjdm3" />;
  if (!onDark) return mark;
  return <span className="inline-flex items-center justify-center rounded-2xl bg-white p-4" data-id="element-206" data-mp="hthwh1tezu29">
      {mark}
    </span>;
}